/*
 * About Us — lightweight, dependency-free slider.
 * Replaces the legacy Glide.js carousels with native CSS scroll-snap
 * plus minimal JS for arrows, bullets and (optional) autoplay.
 */
(function () {
  'use strict';

  function initSlider(slider) {
    if (slider.dataset.aboutInit === '1') return;
    slider.dataset.aboutInit = '1';

    var track = slider.querySelector('.about-slider__track');
    if (!track) return;

    var slides = Array.prototype.slice.call(
      track.querySelectorAll('.about-slider__slide')
    );
    if (slides.length === 0) return;

    var bullets = Array.prototype.slice.call(
      slider.querySelectorAll('.about-slider__bullet')
    );
    var prev = slider.querySelector('.about-slider__arrow--prev');
    var next = slider.querySelector('.about-slider__arrow--next');
    var autoplayMs = parseInt(slider.dataset.autoplay, 10) || 0;
    var autoplayTimer = null;

    function currentIndex() {
      var pos = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(slides[i].offsetLeft - pos);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function updateBullets() {
      if (bullets.length === 0) return;
      var idx = currentIndex();
      for (var i = 0; i < bullets.length; i++) {
        bullets[i].classList.toggle('is-active', i === idx);
      }
    }

    function goTo(index) {
      var max = slides.length - 1;
      var i = index;
      if (i < 0) i = max;
      if (i > max) i = 0;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(currentIndex() - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(currentIndex() + 1);
      });
    }

    bullets.forEach(function (bullet, i) {
      bullet.addEventListener('click', function () {
        goTo(i);
      });
    });

    var rafScheduled = false;
    track.addEventListener('scroll', function () {
      if (rafScheduled) return;
      rafScheduled = true;
      window.requestAnimationFrame(function () {
        updateBullets();
        rafScheduled = false;
      });
    });

    function startAutoplay() {
      if (!autoplayMs || autoplayTimer) return;
      autoplayTimer = window.setInterval(function () {
        goTo(currentIndex() + 1);
      }, autoplayMs);
    }
    function stopAutoplay() {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    if (autoplayMs) {
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('touchstart', stopAutoplay, { passive: true });
      startAutoplay();
    }

    updateBullets();
  }

  function initAll(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('.about-slider');
    Array.prototype.forEach.call(sliders, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-init when the section is (re)loaded in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
